import { render, staticRenderFns } from "./CampusResource.vue?vue&type=template&id=59ec6047&"
import script from "./CampusResource.vue?vue&type=script&lang=js&"
export * from "./CampusResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports